import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

export const useGetMentorMonthlyUpdate = (
  updateId?: string,
  mentorshipId?: string,
) => {
  return useQuery<any>({
    queryKey: ["mentorshipId", mentorshipId, "updateId", updateId],
    queryFn: () =>
      fetchApi({
        url: `v1/mentorships/${mentorshipId}/updates/${updateId}`,
        method: "GET",
      }),
  });
};
